
import { Component, Vue } from 'vue-property-decorator';
import heading from "./components/shared/Heading.vue"
import { GetWorkspacesParams } from './models/StoreClasses';
import Sidebar from '@/components/shared/Sidebar.vue';

@Component({
  components:{heading, Sidebar}
})
export default class App extends Vue {
}
